
/**
 * Helper
 */
var helper = require('../../helper');

/**
 * Other necessary controllers
 */
var ToastrController = new (require('../../services/ToastrController'));

function AddEmploymentHistoryController($modal) {

    // This is how:
    this.$modal = $modal;
    this.$submitButton = $modal.find('.modal-submit-button');
    this.ModalFormController = new (require('../../services/modals/ModalFormController'))($modal);
    this.datatableId = $modal.data('datatable');

    var self = this; // Needed for using all constructor variables inside this function, note the differece -> no "this" but "var" at the beginning

    (function()
    {

        // Someone filled all fields and

        self.$submitButton.click(function(e){

if(document.getElementById("company_name_field").value == null){
    alert('Your form contain errors. Please check all fields again.');
}

            e.preventDefault();


            var values = {};
            $.each($('#employment-history-form').serializeArray(), function(i, field) {
                values[field.name] = field.value;
            });

            $.ajax(
                {
                type: 'POST',
                url: helper.getOrigin() + "/employment-history",
                data: values,
                dataType: 'json',

                success: function(data) {
                  console.log(data);
                    if (data.status == 'error') {
                        ToastrController.showDanger(data.message);
                        console.log($('#employment-history-form').serializeArray());
                        self.ModalFormController.displayErrors(data.errors);
                    } else {
                       
                        self.clearModal();
                        self.closeModal();
                        $('.datatable-employment-history-of-guardian').DataTable().ajax.reload();
                    
                        ToastrController.showSuccess(data.message);

                    }
              
                   
                },

                error: function(data) {

                    var errors = data.responseJSON;
                    
                    // Now display all errors from validation
                    self.ModalFormController.displayErrors(errors);

                }
            });

            return false;
        });

    }());

}

AddEmploymentHistoryController.prototype.clearModal = function() {
    this.ModalFormController.clearModal();
}

AddEmploymentHistoryController.prototype.showModal = function() {
    this.ModalFormController.showModal();
}

AddEmploymentHistoryController.prototype.closeModal = function() {
    this.ModalFormController.closeModal();
}

AddEmploymentHistoryController.prototype.refreshDatatable = function() {

    var $datatableFilter = $(this.datatableId+'_filter'),
        $searchInput = $datatableFilter.find('input');

    $searchInput.val(' ');
    $searchInput.keyup();
    $searchInput.trigger( "keyup" );

}

module.exports = AddEmploymentHistoryController;